<template>
  <div class="edit-video-box">
    <el-dialog
      class="game-dialog"
      :title="'回收金币'"
      :visible.sync="dialogVisible"
      width="400px"
      :before-close="handleClose"
      :close-on-click-modal="false"
      
    >
      <el-form ref="form" label-width="120px">
         <el-row :gutter="24">
          <el-col :lg="24" :md="24" :sm="24" :xl="24" :xs="24">
             <el-form-item label="充值金币">
               <el-input v-model.number="amount" />
                <p style="color:red">只能填写负数</p>
             </el-form-item>
           </el-col>
         </el-row>
         <el-row :gutter="24">
           <el-col :lg="24" :md="24" :sm="24" :xl="24" :xs="24">
             <el-form-item label="收益金币">
               <el-input v-model.number="income" />
                <p style="color:red">只能填写负数</p>
             </el-form-item>
           </el-col>
         </el-row>
         <el-row :gutter="24">
          <el-col :lg="24" :md="24" :sm="24" :xl="24" :xs="24">
             <el-form-item label="操作内容">
               <el-input v-model="mark" />
             </el-form-item>
           </el-col>
         </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" @click="submitEdit()" :loading="flag" size="small">确 认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import API from "@/api";
export default {
  data() {
    return {
      uid: "",
      dialogVisible: false,
      flag: false,
      amount: 0,
      income: 0,
      balance: 0,
      mark: "",
      transferaBle: 0,
    };
  },
  methods: {
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.balance = 0;
      this.transferaBle = 0;
      this.incomeCoin = 0;
      this.$refs["form"].resetFields();
    },
    // 确认修改
    // handleOK() {
    //   this.$refs["form"].validate((valid) => {
    //     if (valid) {
    //       this.flag = true;
    //       this.submitEdit();
    //     } else {
    //       return false;
    //     }
    //   });
    // },
    // 提交修改
    submitEdit() {
      if (this.amount > 0 || this.income > 0) {
        this.$message({
          message: "金额只能是负数",
          type: "error",
        });
        return;
      }
      if (this.amount == 0 && this.income == 0) {
        this.$message({
          message: "操作金额不能为0",
          type: "error",
        });
        return;
      }
      let params = {
        uid: this.uid,
      };
      if (this.mark === "") {
        this.$message({
          message: "请输入备注",
          type: "error",
        });
        return;
      } else {
        params.mark = this.mark;
      }
      if (this.amount < 0) {
        params.amount = this.amount;
      }
      if (this.income < 0) {
        params.income = this.income;
      }
      this.flag = true;
      API.recycleIncome(params)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "回收成功",
              type: "success",
            });
            this.amount = 0;
            this.income = 0;
            this.mark = "";
          } else {
            this.$message.error(res.data);
          }
          this.flag = false;
          // this.handleClose();
        })
        .catch(() => {
          this.flag = false;
          // this.handleClose();
        });
    },
    // 打开弹窗、传递需要编辑的参数
    open(row) {
      this.uid = row.uid;
      let params = {
        uid: row.uid
      }
      this.dialogVisible = true;
      this.flag = true;
      API.queryBalance(params)
      .then((res) => {
        if (res.code === 200) {
          this.balance = res.data.wlBalance;
          this.transferaBle = res.data.wlTransferable;
        } else {
          this.$message.error("回收失败");
        }
        this.flag = false;
      })
      .catch(() => {
        this.flag = false;
      });
    },
  },
};
</script>

<style lang="scss">
.edit-video-box {
  .el-input {
    width: 150px;
  }
}
.form_item {
  display: flex;
}
.game-dialog {
  .el-dialog__body {
    padding: 25px 25px 0 !important;
  }
}
</style>
